export default __webpack_public_path__ + "2022_03_01_16_57/media/credit_card.b04cb874.svg";